import React from 'react';
import * as Styled from './styled';

interface NoDataPanelProps {
  msg?: string;
}

function NoDataPanel({
  msg = 'NO DATA TO DISPLAY',
}: NoDataPanelProps): JSX.Element {
  return <Styled.NoDataPanel as="div">{msg}</Styled.NoDataPanel>;
}

export default NoDataPanel;
